import '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import { S as SvgDiv, a as Svg } from '../Svg-0180d7b5.js';
import InfoGlyph from './InfoGlyph.js';

function InfoIcon({
  glyph,
  role,
  size = 128,
  rotate,
  viewBox = '0 0 256 256',
  styles = {}
}) {
  return /*#__PURE__*/createElement(SvgDiv, _extends({
    testId: "icon",
    rotate: rotate,
    size: size,
    role: role
  }, styles.root), /*#__PURE__*/createElement(Svg, {
    viewBox: viewBox,
    id: glyph
  }, /*#__PURE__*/createElement(InfoGlyph, {
    glyph: glyph
  })));
}

export default InfoIcon;
